import { TitleType } from 'api';
import { createEnumOptions } from 'const/createEnumOptions';
import { getTitleTypeName } from './titleTypeHelpers';

export const TITLE_TYPE_OPTIONS = createEnumOptions(TitleType, getTitleTypeName);
